var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayoutSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 94,
    viewBox: "0 0 86 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.0833 69.6944H0V76.8611H68.0833V69.6944Z",
    fill: "#B1C1D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3333 86.4166H10.75V93.5833H57.3333V86.4166Z",
    fill: "#B1C1D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5501 22.3695V9.47698H43.685L34.5425 0.416626L25.5369 9.47698H12.6443V22.3695L3.58398 31.3751L12.6443 40.5176V53.3828H25.5369L34.5425 62.4431L43.685 53.3828H56.5501V40.5176L65.6105 31.3751L56.5501 22.3695Z",
    fill: "#406DB6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3139 17.2757C27.9964 17.2757 30.1589 19.4381 30.1589 22.148C30.1589 23.433 29.6484 24.6653 28.7398 25.5739C27.8312 26.4825 26.5989 26.993 25.3139 26.993C22.604 26.993 20.4416 24.8305 20.4416 22.148C20.4416 19.4381 22.604 17.2757 25.3139 17.2757ZM42.805 44.5115C40.1225 44.5115 37.9601 42.3217 37.9601 39.6391C37.9601 38.3542 38.4705 37.1218 39.3791 36.2132C40.2877 35.3046 41.5201 34.7942 42.805 34.7942C45.4876 34.7942 47.6774 36.9566 47.6774 39.6391C47.6774 40.9314 47.164 42.1707 46.2503 43.0844C45.3366 43.9981 44.0973 44.5115 42.805 44.5115ZM24.4106 44.5936L20.3047 40.4877L43.6536 17.1388L47.7595 21.2447L24.4106 44.5936Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9996 11.5754L67.7261 29.0833L58.5273 20.6782L61.4354 17.8805L67.7261 23.468L83.0915 8.77771L85.9996 11.5754Z",
    fill: "#41D17E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayoutSign);
export default __webpack_public_path__ + "static/media/payout_sign.51292993ea943edf79e1586879ac1fb3.svg";
export { ForwardRef as ReactComponent };